import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2f8f37ba"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=2f8f37ba&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=2f8f37ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports